import { render, staticRenderFns } from "./StudyRadTags.vue?vue&type=template&id=70cd5698&scoped=true"
import script from "./StudyRadTags.vue?vue&type=script&lang=js"
export * from "./StudyRadTags.vue?vue&type=script&lang=js"
import style0 from "./StudyRadTags.vue?vue&type=style&index=0&id=70cd5698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd5698",
  null
  
)

export default component.exports